import type { VulpariNode } from "@vulpari/core";
import { useState } from "react";

import { useStore } from "../store.js";
import { Icon, type IconName } from "./Icon.js";

const TYPES: { type: VulpariNode["type"]; label: string; icon: IconName }[] = [
  { type: "account", label: "Account", icon: "bank" },
  { type: "card", label: "Credit", icon: "credit-card" },
  { type: "income", label: "Income", icon: "money-wavy" },
  { type: "bill", label: "Bill", icon: "receipt" },
  { type: "oneoff", label: "One-off", icon: "calendar-dot" },
  { type: "pot", label: "Pot", icon: "piggy-bank" },
  { type: "external", label: "External", icon: "storefront" },
];

export function AddNodeMenu() {
  const addNode = useStore((state) => state.addNode);
  const [open, setOpen] = useState(false);

  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => setOpen((value) => !value)}
        className="flex items-center gap-1.5 rounded-lg bg-accent px-3 py-1.5 text-sm font-medium text-canvas hover:opacity-90"
      >
        <Icon name="plus" size={16} />
        Add node
      </button>

      {open ? (
        <>
          {/* Click-away layer. */}
          <button
            type="button"
            aria-hidden
            tabIndex={-1}
            className="fixed inset-0 z-10 cursor-default"
            onClick={() => setOpen(false)}
          />
          <div className="absolute left-0 z-20 mt-1 w-40 overflow-hidden rounded-lg border border-node-border bg-node-bg shadow-xl">
            {TYPES.map((entry) => (
              <button
                key={entry.type}
                type="button"
                onClick={() => {
                  void addNode(entry.type);
                  setOpen(false);
                }}
                className="flex w-full items-center gap-2 px-3 py-2 text-left text-sm text-ink hover:bg-canvas"
              >
                <Icon name={entry.icon} size={16} className="text-ink-muted" />
                {entry.label}
              </button>
            ))}
          </div>
        </>
      ) : null}
    </div>
  );
}
